import { MdOutlineAddCircle } from "react-icons/md";
import {Button} from "primereact/button";

const AddButton = ({ onClick, tooltip, size="1.4rem" }) => {
    return (
        <Button
            type="button"
            icon={<MdOutlineAddCircle size={size} />}
            className="action-body-btn action-body-btn-add"
            tooltip={tooltip || "Agregar"}
            tooltipOptions={{ position: "top" }}
            onClick={onClick}
            aria-label={tooltip || "Agregar"}
        />
    );
};

export default AddButton;